export default __webpack_public_path__ + "static/media/check_normal.03d72f73.svg";